import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Choose',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/ChooseView')
  },
  {
    path: '/start',
    name: 'Start',
    component: () => import('@/views/StartView')
  },
  {
    path: '/agency',
    name: 'Agency',
    component: () => import('@/views/AgencyView')
  },
  {
    path: '/price',
    name: 'Price',
    props: (r) => ({ apptId: Number(r.query.appt_id) }),
    component: () => import('@/views/PriceView')
  },
  {
    path: '/booking',
    name: 'Booking',
    props: (r) => ({ apptId: Number(r.query.appt_id) }),
    component: () => import('@/views/BookingView')
  },
  {
    path: '/confirm',
    name: 'Confirm',
    props: (r) => ({
      apptId: Number(r.query.appt_id),
      dateTime: r.query.dateTime
    }),
    component: () => import('@/views/ConfirmView')
  },
  {
    path: '/contact',
    name: 'Contact',
    props: (r) => ({
      apptId: Number(r.query.appt_id),
      dateTime: r.query.dateTime
    }),
    component: () => import('@/views/ContactView')
  },
  {
    path: '/success',
    name: 'Success',
    props: (r) => ({ confirm: r.query.confirm, dateTime: r.query.dateTime }),
    component: () => import('@/views/SuccessView')
  }
]

const router = new VueRouter({
  routes
})

export default router
